export default "__VITE_ASSET__DxZUe1um__"